import React, { useState } from "react";
import PropTypes from "prop-types";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";
import Image from "../global/Image";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Navigation,
  Pagination,
  Mousewheel,
  Keyboard,
  Controller,
  Thumbs,
} from "swiper/modules";
import "swiper/css";
import Video from "../global/Video";
import Progress from "../global/Progress";

/********************************
<Gallery />
/********************************
Version: 1.2
Created: 25 08 2023
Updated: 19 02 2025
Author: Richy Pears
/********************************
Gallery for use in the games page
and as an independant section

TODO: Make it accessible
/********************************/

/********************************
<Gallery />
/********************************
PLACEHOLDER
/********************************
Displays intro copy
/********************************/

const Gallery = ({ blok }) => {
  const [activeIndex, setActiveIndex] = useState(1);

  if (!blok) return null; // Escape hatch
  const {
    autoplay,
    copy,
    items,
    number,
    orientation = "auto",
    padding,
    rounded,
    subtitle,
    theme,
    title,
  } = blok;

  const colour = SmartColour(theme);

  const randomId =
    "brand_controller_wrapper_gallery_" + Math.floor(Math.random() * 100) + 1; // Random string created for unique ID

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
      id={randomId}
    >
      <div className="brand-container flex flex-col gap-5 md:gap-10">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {title && <h1 className="m-0 text-center">{title}</h1>}
        {copy?.content[0]?.content && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
      </div>

      <div className="brand-controller-wrapper w-full px-5 py-10 md:py-12 max-w-[1400px] mx-auto">
        <Swiper
          autoHeight={false}
          autoplay={
            autoplay === "false"
              ? false
              : {
                  delay: autoplay,
                  disableOnInteraction: true,
                  pauseOnMouseEnter: true,
                }
          }
          centeredSlides={true}
          grabCursor={true}
          loop={false}
          modules={[
            Autoplay,
            Thumbs,
            Navigation,
            Pagination,
            Mousewheel,
            Keyboard,
            Controller,
          ]}
          navigation={{
            prevEl: `#${randomId} .brand-controller-button-previous`,
            nextEl: `#${randomId} .brand-controller-button-next`,
          }}
          slidesPerView={1}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex + 1)}
        >
          {items &&
            items.map((node, index) => {
              return (
                <SwiperSlide className="w-auto max-w-full md:max-h-md lg:max-h-lg xl:max-h-xl">
                  <div>
                    {node.video ? (
                      <Video
                        video={node.video}
                        aspect={orientation}
                        className="w-auto max-w-full mx-auto md:max-h-md lg:max-h-lg xl:max-h-xl rounded-3xl"
                      />
                    ) : (
                      <Image
                        src={node.image}
                        aspect={orientation}
                        className="w-auto max-w-full mx-auto md:max-h-md lg:max-h-lg xl:max-h-xl rounded-3xl"
                      />
                    )}
                    {node.caption && (
                      <div className="bg-black/25 text-white brand-text-small mt-1 md:mt-0 rounded-lg p-2 md:p-4 md:absolute md:bottom-10 md:right-10">
                        {node.caption}
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
      <div className="brand-container flex flex-row justify-between md:justify-end items-center gap-5">
        <span className="brand-button aspect-square w-12 p-0 brand-controller-button-previous order-1">
          <span className="material-icons text-4xl brand-icon-start">
            chevron_left
          </span>
        </span>
        <span className="brand-button aspect-square w-12 p-0 brand-controller-button-next order-3 md:order-2">
          <span className="material-icons text-4xl">chevron_right</span>
        </span>
        <Progress
          current={activeIndex && activeIndex}
          total={items && items.length}
          css="font-medium tracking-[4px] uppercase m-0 text-xs md:text-base order-2 md:order-3"
        />
      </div>
    </section>
  );
};

export default Gallery;

Gallery.defaultProps = {
  blok: null,
};

Gallery.propTypes = {
  blok: PropTypes.object,
};
